import React, {Fragment, useState} from 'react';
import {Section, List, Popup, Explanation_text} from '../../../components';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import PersonIcon from '@material-ui/icons/Person';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import UserSection from './UserSection';
import CancelIcon from '@material-ui/icons/Cancel';
import New_user_popup from './New_user_popup';
import {connect} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';



const useStyles = makeStyles((theme) => ({
  flexy:{
    left:'90px',
    ['@media (max-width:600px)']:{left:'20px'}
  },
  link:{backgroundColor:theme.palette.tertiary.main, color:'white'},
}));


function Team(props){
  const[user_id, setUserId]=useState(props.me.user_workspace_id);
  const[new_user_popup, setNewUserPopup]=useState(false);
  const[user_list_in, setUserListIn]=useState(false);
  const[no_extra, setNoExtra]=useState(false);
  const classes=useStyles(props);
  let w_limit=null; if(props.workspace!=null && props.workspace!=undefined && props.workspace.free_account!=true){w_limit=(props.workspace.active_subscription==null)?1:props.workspace.active_subscription.max_users;}
  let users=[]; let users_length=0; if(props.workspace!=undefined){for(let uk in props.workspace.all_user_workspaces){let u=props.workspace.all_user_workspaces[uk]; if(u.invisible!=true){if(u.superuser!=true && u.user_id!=null && u.user_id!=undefined){users_length+=1;} users.push({id:u.id, icon:(u.user_id==null || u.user_id==undefined)?<CancelIcon color='secondary' disabled={no_extra}/>:(u.new==true)?<FiberNewIcon color='secondary'/>:(u.admin==false)?<PersonIcon color='primary'/>:<SupervisorAccountIcon color='primary'/>,  main_text:u.first_name+' '+u.last_name});}}}

  if(users_length>=w_limit && no_extra==false && props.workspace!=undefined && props.workspace.free_account!=true && props.workspace.backend_account!=true){setNoExtra(true);}

  function userSelected(data){setUserId(data.id); setUserListIn(false);}
  let max_users=1; if(props.workspace!=undefined && props.workspace.active_subscription!=undefined){max_users=props.workspace.active_subscription.max_users;}
  return(
    <Fragment>
      <div className={classes.flexy} style={{position:'absolute', top:'60px'}}><Button variant='contained' color='secondary' disabled={(props.workspace!=undefined && (props.workspace.free_account==true || props.workspace.backend_account==true))?false:(props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.canceled_on!=null)?true:(max_users<=users_length)} onClick={()=>{if((max_users>users_length) || (props.workspace!=undefined && (props.workspace.free_account==true || props.workspace.backend_account==true))){setNewUserPopup(true);}}}>New user</Button></div>
      <div style={{position:'absolute', top:'60px', right:'30px'}}><Button variant='contained' className={classes.link} onClick={()=>{setUserListIn(true);}}>Select user</Button></div>
      {(users.length==0 || w_limit==null)?null:<div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'120px', maxWidth:'500px', marginBottom:'-100px', height:'25px', borderRadius:'5px', borderColor:'orange', borderStyle:'solid', borderWidth:'1px', backgroundColor:'white', position:'relative'}}><Typography style={{position:'relative'}}><div style={{borderRightWidth:'1px', borderRightStyle:'solid', borderRightColor:'grey', alignItems:'center', justifyContent:'center', height:'25px', position:'absolute', left:'0px', top:'0px', width:'50px', textAlign:'center', display:'flex', justifyContent:'center', alignItems:'center'}}><div>{users_length+'/'+w_limit}</div></div><div style={{marginLeft:'60px', width:'calc(100% - 60px)', height:'25px', display:'flex', justifyContent:'center', alignItems:'center'}}><a href='/payments/subscriptions'>Upgrade subscription?</a></div></Typography></div>}
      <Slide direction="left" in={user_list_in} mountOnEnter unmountOnExit>
        <div style={{position:'absolute', backgroundColor:'white', zIndex:'100', top:'0px', right:'0px', width:'300px', height:'100vh', boxShadow:'-2px 2px 10px 1px #888888'}}>
        <div style={{height:'40px'}}></div>
        <div style={{position:'relative', width:'100%', height:'calc(100vh - 60px)'}}><List background_colour='rgba(255,255,255,1)' small_text list_data={users} onClick={userSelected}/></div>
        </div>
      </Slide>
      <UserSection current_user_count={users_length} user_id={user_id} {...props} no_extra={no_extra}/>
      {(new_user_popup!=true)?null:<New_user_popup {...props} current_user_count={users_length} handleClose={()=>{setNewUserPopup(false);}}/>}
    </Fragment>
  )
}




export default connect(ss, dd)(Team);


function ss(state){
  return{
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id]
  }
}

function dd(dispatch){
  return{

  }
}
